import { IonModal, IonIcon, IonButton } from '@ionic/react';
import { shareOutline, addCircleOutline, checkmarkCircleOutline } from 'ionicons/icons';
import { FC } from 'react';

interface IOSInstallSheetProps {
  isOpen: boolean;
  onClose: () => void;
  browser?: 'safari' | 'chrome';
}

const IOSInstallSheet: FC<IOSInstallSheetProps> = ({ isOpen, onClose, browser = 'safari' }) => (
  <IonModal
    isOpen={isOpen}
    onDidDismiss={onClose}
    backdropDismiss={true}
    className="ios-install-sheet"
  >
    <div className="ios-install-sheet__content">
      <div className="ios-install-sheet__handle" />

      <h2 className="ios-install-sheet__title">Add to Home Screen</h2>
      <p className="ios-install-sheet__subtitle">
        {browser === 'chrome'
          ? 'Follow these steps in Chrome to install Slot Check:'
          : 'Follow these steps in Safari to install Slot Check:'}
      </p>

      <div className="ios-install-sheet__steps">
        <div className="ios-install-step">
          <div className="ios-install-step__icon-wrap">
            <IonIcon icon={shareOutline} />
          </div>
          <div className="ios-install-step__text">
            <strong>Tap the Share button</strong>
            <span>
              {browser === 'chrome'
                ? 'at the top of your Chrome browser'
                : 'at the bottom of your Safari browser'}
            </span>
          </div>
        </div>

        <div className="ios-install-step">
          <div className="ios-install-step__icon-wrap">
            <IonIcon icon={addCircleOutline} />
          </div>
          <div className="ios-install-step__text">
            <strong>Tap "Add to Home Screen"</strong>
            <span>scroll down in the share sheet to find it</span>
          </div>
        </div>

        <div className="ios-install-step">
          <div className="ios-install-step__icon-wrap">
            <IonIcon icon={checkmarkCircleOutline} />
          </div>
          <div className="ios-install-step__text">
            <strong>Tap "Add"</strong>
            <span>to confirm and install the app</span>
          </div>
        </div>
      </div>

      <IonButton expand="block" className="ios-install-sheet__done-btn" onClick={onClose}>
        Got it
      </IonButton>
    </div>
  </IonModal>
);

export default IOSInstallSheet;
